import React, { useState, useContext, useEffect, useMemo } from 'react';
import Select from 'react-select';
import { CategoryContext } from '../../CategoryContext';

const CategoryFilter = ({ filters, setFilters, availableCategories }) => {
  const categories = useContext(CategoryContext);
  const [selectedCategory, setSelectedCategory] = useState(filters.category || null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '25px',
    }),
  };

  // Generate category options considering availableCategories
  const categoryOptions = useMemo(() => {
    return categories
      .filter(cat => !cat.parent_id && (availableCategories ? availableCategories.includes(cat.id) : true))
      .map(cat => ({ value: cat.id, label: cat.name }));
  }, [categories, availableCategories]);

  // Generate subcategory options considering availableCategories

  const subcategoryOptions = useMemo(() => {
    return categories
      .filter(cat => cat.parent_id === (selectedCategory ? selectedCategory.value : null) &&
        (availableCategories ? availableCategories.includes(cat.id) : true))
      .map(subcat => ({ value: subcat.id, label: subcat.name }));
  }, [categories, selectedCategory, availableCategories]);

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setSelectedSubcategory(null); // Reset subcategory when changing main category
    setFilters(prevFilters => ({
      ...prevFilters,
      category: selectedOption ? selectedOption.value : '',
      subcategory: '',
    }));
  };

  const handleSubcategoryChange = (selectedOption) => {
    setSelectedSubcategory(selectedOption);
    setFilters(prevFilters => ({
      ...prevFilters,
      subcategory: selectedOption ? selectedOption.value : '',
    }));
  };

  useEffect(() => {
    const categoryId = filters.category;
    const subcategory = categories.find(cat => cat.id === categoryId && cat.parent_id !== null);

    if (subcategory) {
      // It's a subcategory, find the parent
      const parentCategory = categories.find(cat => cat.id === subcategory.parent_id);
      if (parentCategory) {
        const parentOption = categoryOptions.find(opt => opt.value === parentCategory.id);
        const subOption = subcategoryOptions.find(opt => opt.value === subcategory.id);

        setSelectedCategory(parentOption);
        setSelectedSubcategory(subOption);

        // Update filters to parent and subcategory
        setFilters(prevFilters => ({
          ...prevFilters,
          category: parentCategory.id,
          subcategory: subcategory.id,
        }));
      }
    } else {
      // Main category or empty
      const category = categoryOptions.find(cat => cat.value === categoryId) || null;
      const subcategory = subcategoryOptions.find(sub => sub.value === filters.subcategory) || null;
      setSelectedCategory(category);
      setSelectedSubcategory(subcategory);
    }
  }, [filters, categories, setFilters, categoryOptions, subcategoryOptions]);

  return (
    <div className="category-filter">
      <h3>Kategorije</h3>
      <div className="category_filter_box" style={{ marginBottom: '16px' }}>
        <Select
          options={categoryOptions}
          value={selectedCategory}
          onChange={handleCategoryChange}
          placeholder="Izberi kategorijo"
          isClearable
          isSearchable={false}
          styles={customStyles}
        />
      </div>

      {selectedCategory && subcategoryOptions.length > 0 && (
        <div>
          <Select
            options={subcategoryOptions}
            value={selectedSubcategory}
            onChange={handleSubcategoryChange}
            placeholder="Izberi podkategorijo"
            isClearable
            isSearchable={false}
            styles={customStyles}
          />
        </div>
      )}
    </div>
  );
};

export default CategoryFilter;